import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import '../src/assets/styles/_app.scss';
import App from './app';
import * as serviceWorker from './serviceWorker';

import AppContext from "./app/appContext";
import store from './redux/store';
import routes from "./app/RootRoute";
import { Provider } from 'react-redux';

ReactDOM.render(
    <AppContext.Provider value={{ routes }}>
        <Provider store={store}>
            <App />
        </Provider>
    </AppContext.Provider>, document.getElementById('root'));

serviceWorker.unregister();
